// src/pages/NewHome.js
import React, { useEffect, useMemo, useRef, useState } from "react";
import mainimagein from '../Images/mainscreengif.gif';
import myVideo from "../Images/landingscreenvideo.mp4";
import { Link } from "react-router-dom";

const NewHome = () => {
  const [vw, setVw] = useState(typeof window !== "undefined" ? window.innerWidth : 1280);
  const [navOpen, setNavOpen] = useState(false);
  const projectsRef = useRef(null);

  useEffect(() => {
    const onResize = () => setVw(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const bp = useMemo(
    () => ({
      isMobile: vw < 640,
      isTablet: vw >= 640 && vw < 1024,
      isDesktop: vw >= 1024,
      container: vw < 640 ? 16 : vw < 1024 ? 24 : 40,
      gridCols: vw < 640 ? 1 : vw < 1024 ? 2 : 3,
    }),
    [vw]
  );

  const palette = {
    bg: "#0f172a", // slate-900
    surface: "#111827", // gray-900
    surfaceAlt: "#0b1220", // deep navy
    text: "#e5e7eb", // gray-200
    textMuted: "#9ca3af", // gray-400
    brand: "#f59e0b", // amber-500
    brandDark: "#b45309", // amber-700
    line: "#1f2937", // gray-800
    white: "#ffffff",
    success: "#10b981",
  };

  const container = {
    maxWidth: 1180,
    margin: "0 auto",
    paddingLeft: bp.container,
    paddingRight: bp.container,
  };

  const btnBase = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 10,
    height: 48,
    padding: "0 18px",
    borderRadius: 999,
    fontWeight: 600,
    border: `1px solid ${palette.line}`,
    cursor: "pointer",
    transition: "all .2s ease",
    textDecoration: "none",
    whiteSpace: "nowrap",
  };

  return (
    <section
      style={{
        position: "relative",
        // background: `linear-gradient(180deg, rgba(15,23,42,0.2), rgba(15,23,42,0.4)), url(${mainimagein}) center/cover no-repeat`,
        // background: `linear-gradient(180deg, rgba(15,23,42,0.6), rgba(15,23,42,0.9)), url('https://images.unsplash.com/photo-1504307651254-35680f356dfd?q=80&w=2400&auto=format&fit=crop') center/cover no-repeat`,
        color: palette.white,
        backgroundAttachment: "fixed", // parallax effect
        overflow: "hidden",
      }}
    >
      <video
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
          // parallax effect

        }}
      >
        <source src={myVideo} type="video/mp4" />
      </video>
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "linear-gradient(180deg, rgba(15,23,42,0.6), rgba(15,23,42,0.9))",
          zIndex: 1,
        }}
      />
      <div
        style={{
          ...container,
          position: "relative",
          zIndex: 2, // ✅ THIS IS KEY
          paddingTop: bp.isMobile ? 48 : 84,
          paddingBottom: bp.isMobile ? 64 : 120,
        }}
      >

        <div style={{ maxWidth: 760 }}>
          <h1
            style={{
              fontSize: bp.isMobile ? 36 : 56,
              lineHeight: 1.1,
              margin: 0,
              fontWeight: 800,
              textTransform: "capitalize",
            }}
          >
            Designing Innovative Structures — for a Sustainable Future.
          </h1>
          <p
            style={{
              color: palette.text,
              marginTop: 16,
              fontSize: bp.isMobile ? 16 : 18,
              // textTransform: "capitalize",
            }}
          >
            From Concept to Completion, We Deliver Safe, Efficient, and High-Quality Structural Solutions Across Industrial, Storage and Commercial Projects.
          </p>
          <div
            style={{
              display: "flex",
              gap: 12,
              marginTop: 24,
              flexWrap: "wrap",
            }}
          >
            <Link
              to="/Projects"
              style={{
                ...btnBase,
                background: palette.white,
                color: palette.bg,
                borderColor: "transparent",
              }}
            >
              View Projects
            </Link>


            <Link
              to="/Contact"
              style={{ ...btnBase, background: "transparent", color: palette.white }}
            >
              Talk to Us →
            </Link>
          </div>
        </div>

        {/* Stats strip */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: bp.isMobile ? "1fr 1fr" : "repeat(auto-fit, minmax(200px, 1fr))",
            gap: 14,
            marginTop: bp.isMobile ? 28 : 48,
            // background:'red',
            // justifySelf:'center'
          }}
        >
          {[
            // { k: "13+", v: "Years Experience" },
            { k: "10,000+", v: "Projects Delivered" },
            { k: "0.68", v: "EMR Safety Rating" },
            { k: "98%", v: "On-Time Delivery" },
          ].map((s) => (
            <div
              key={s.v}
              style={{
                background: "rgba(17,24,39,0.7)",
                border: `1px solid ${palette.line}`,
                borderRadius: 16,
                padding: 18,
              }}
            >
              <div style={{ fontSize: 24, fontWeight: 800 }}>{s.k}</div>
              <div style={{ color: palette.text }}>{s.v}</div>

            </div>
          ))}
        </div>

      </div>

    </section>
  );
};

export default NewHome;

